import { Validators } from "@angular/forms";

export const environment = {
  production: true,
  base_url: 'media/',
  ws_url: 'wss://nuuduu.com/media',
  version: '2026-05-24 06:49:37 +0300 ba4646f',
  version_hash: 'ba4646f',
  languages: ["fi", "ee", "lt", "lv", "sv"],
  locales: ['en', 'et', 'fi',  'lt', 'lv', 'sv'],
  supported_languages: ['ar', 'et', 'fi', 'ga', 'lt', 'lv', 'mt', 'pl', 'ru', 'sv', 'tl'],
  currency: 'EUR',
  national_id_validators: [Validators.pattern(/^$|^[1-6]\d{2}[0-1]\d[0-3]\d{4}$/)],
  payment_apis: {},
  integrations: [] as string[]
}
